import { type ReactNode } from "react";

type Props = {
  className?: string;
  children: ReactNode;
};

export function MessageBubble({ className, children }: Props) {
  return (
    <div
      className={`max-w-[85%] rounded-xl bg-sub px-3 py-2 text-sm ${className ?? ""}`}
    >
      {children}
    </div>
  );
}
